"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ndarray = require('ndarray');
var pool = require('typedarray-pool');
var cwise = require('cwise');
var Mesher_1 = require('@voxeline/mesher/lib/Mesher');
var NavMesh_1 = require('./NavMesh');
var surfaceStencil = cwise({
    args: [
        'array', 'array', { offset: [1, 0, 1], array: 1 }, { offset: [1, 1, 1], array: 1 },
    ],
    body: function (o1, a, a101, a111) {
        o1 = a111 ? 0 : a101;
    },
});
var NavMesher = (function (_super) {
    __extends(NavMesher, _super);
    function NavMesher() {
        _super.apply(this, arguments);
    }
    NavMesher.prototype.append = function (loX, loY, hiX, hiY, val) {
        var z = this.z;
        this.navmesh.addPolygon(loX, loY, hiX, hiY, z);
    };
    NavMesher.prototype.build = function (padded, x, y, z) {
        var unpadded = this.unpad(padded);
        var shape = unpadded.shape;
        var sz = shape[0] * shape[1] * shape[2];
        var scratch1 = pool.mallocInt32(sz);
        var ao1 = ndarray(scratch1, unpadded.shape);
        surfaceStencil(ao1, unpadded);
        this.navmesh = new NavMesh_1.default(x, y, z, shape[0] - 1, shape[1] - 1, shape[2] - 1);
        this.computeSurface(1, ao1);
        // Release buffers
        pool.freeInt32(scratch1);
        var navmesh = this.navmesh;
        this.navmesh = null;
        navmesh.computeEdges();
        return navmesh;
    };
    return NavMesher;
}(Mesher_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = NavMesher;
//# sourceMappingURL=NavMesher.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/pathfinder/lib/NavMesher.js
 ** module id = 1157
 ** module chunks = 0
 **/